import { render, staticRenderFns } from "./status.vue?vue&type=template&id=10b8fa65&"
import script from "./status.vue?vue&type=script&lang=ts&"
export * from "./status.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/aef.slmndr.be/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10b8fa65')) {
      api.createRecord('10b8fa65', component.options)
    } else {
      api.reload('10b8fa65', component.options)
    }
    module.hot.accept("./status.vue?vue&type=template&id=10b8fa65&", function () {
      api.rerender('10b8fa65', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/estates/status.vue"
export default component.exports